import { put, call, all, takeEvery, delay } from "redux-saga/effects";
import axios from "axios";
import singleAdmitcardActions from "./action";
import { API_URL } from "../../utils/constants";
import commonActions from "../common/actions";

// The endpoint answers with the PDF itself on success and JSON on failure, so a
// failed request arrives here as a Blob that still has to be read as text.
const readBlobMessage = (blob) =>
  new Promise((resolve) => {
    if (!blob || typeof blob.text !== "function") return resolve(null);
    blob
      .text()
      .then((text) => {
        try {
          resolve(JSON.parse(text)?.message || null);
        } catch (e) {
          resolve(null);
        }
      })
      .catch(() => resolve(null));
  });

const generateSingleAdmitcard = function* (data) {
  const { payload } = data;

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });
  yield put({ type: commonActions.SET_PAGE_LOADER, payload: true });

  try {
    const response = yield call(() =>
      axios.post(
        `${API_URL}/backoffice/single-admitcard/generate`,
        {
          courseid: payload?.courseid,
          searchvalue: payload?.searchvalue,
          withVenue: payload?.withVenue,
          rereleaseDate: payload?.rereleaseDate,
        },
        { responseType: "blob" }
      )
    );

    const disposition = response?.headers?.["content-disposition"] || "";
    const matched = /filename="?([^";]+)"?/.exec(disposition);
    const fileName = matched?.[1] || `admitcard_${payload?.searchvalue}.pdf`;

    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: "application/pdf" })
    );
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    window.URL.revokeObjectURL(url);
    document.body.removeChild(link);

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: "success",
        show: true,
        message: "Admit card generated and downloaded successfully",
      },
    });

    if (payload?.onSuccess) payload.onSuccess();

    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {
    const message =
      (yield call(readBlobMessage, err?.response?.data)) ||
      "Failed to generate admit card";

    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: "failed", show: true, message },
    });

    yield delay(3000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } finally {
    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
    yield put({ type: commonActions.SET_PAGE_LOADER, payload: false });
  }
};

const SingleAdmitcardSagas = function* () {
  yield all([
    yield takeEvery(
      singleAdmitcardActions.GENERATE_SINGLE_ADMITCARD,
      generateSingleAdmitcard
    ),
  ]);
};

export default SingleAdmitcardSagas;
